import { useEffect } from 'react';

import { useFacilitiesQuery } from '@/hooks/useFacilitiesQuery';
import { Chameleon } from '@/lib/Chameleon';
import { UserModel } from '@/models/UserModel';

export const useProductTourIntegrations = (user: UserModel) => {
  const { data: facility } = useFacilitiesQuery().useFindOne(user.facility_id);
  const facilityType = facility?.facility_type;

  useEffect(() => {
    Chameleon.identify(user, facilityType);
  }, [user, facilityType]);
};
